//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventSaleCard from '@/components/eventSale/card.vue';

export default {
  components: {
    EventSaleCard,
  },
  layout: 'scaled',
  data() {
    return {
      variant: 'a',
      data: null,
    };
  },
  head() {
    const title = this.metaTitle;
    const description = this.metaDescription;

    return {
      title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
        {
          hid: 'og:url',
          name: 'og:url',
          property: 'og:url',
          content: `https://${this.$app.config.current.domain}${this.$route.path}`,
        },
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: title,
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: description,
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: `https://${
            this.$store?.state?.host
          }${require(`~/assets/${this.$app?.config?.common?.currentCountry}/ebac-logo.png`)}`,
        },
        {
          hid: 'og:type',
          name: 'og:type',
          property: 'og:type',
          content: 'website',
        },
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex, follow',
        },
      ],
      bodyAttrs: {
        class: 'body--eventSale',
      },
      link: [
        {
          rel: 'preload',
          as: 'image',
          href: require('~/assets/images/event-sale/background.svg'),
        },
        {
          rel: 'preload',
          as: 'image',
          href: require('~/assets/images/event-sale/background-mobile.svg'),
        },
      ],
    };
  },
  computed: {
    /** Заголовок для метатега \ название вкладки */
    metaTitle() {
      return this.getMetaTitle();
    },
    /** Описание для метатегов description и og:description */
    metaDescription() {
      return this.getDescription();
    },
    /** Заголовок H1 на странице - слева */
    firstHeading() {
      const eventType = this.$t(`sale.event_type.${this.data?.event_type}`);
      return `${this.$t('webinarSale.first.title')} ${eventType}`;
    },
    startDateString() {
      return this.formatDate(this.data?.topic_date_utc);
    },
  },
  created() {
    const variant = this.$route.query.type;
    if (variant === 'b') this.variant = 'b';
  },
  methods: {
    saleGetted(data) {
      this.data = data;
    },
    formatDate(textUtcDate) {
      return this.$dayjs
        .utc(textUtcDate)
        .utcOffset(this.$app.config.current.utcOffset)
        .format('DD.MM.YYYY');
    },
    /** Получить заголовок для метатега \ названия вкладки */
    getMetaTitle({ withDate = true } = {}) {
      const prefix = 'EBAC | Discount';

      const type = this.data?.nomenclature_type;
      const typeText = this.$t(
        `sale.nomenclature_type.${type}.en`,
      ).toLowerCase();

      const name = this.data?.nomenclature_name;
      const date = this.startDateString;

      if (withDate) return `${prefix} ${typeText} ${name} ${date}`;
      return `${prefix} ${typeText} ${name}`;
    },
    /** Получить описание для метатегов description и og:description */
    getDescription() {
      const metaTitle = this.getMetaTitle({ withDate: false });
      const heading = this.firstHeading.toLowerCase();

      return `${metaTitle} - ${heading}`;
    },
  },
};
